module.exports = __webpack_public_path__ + "76f35a668b022dbde679ded315116b52.png";